import {
  loader as unifiedCreditPolicyLoader,
  default as UnifiedCreditPolicies
} from "../../../unified-dashboard/src/pages/CreditPolicy";

export const loader = unifiedCreditPolicyLoader;

const CreditPolicy = ({ pageName }: { pageName: string }) => {
  return <UnifiedCreditPolicies pageName={pageName} />;
};

export default CreditPolicy;
